import axios from "axios";
import { API_URL } from "../apiConfig";

const authHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token");
  return { Authorization: `Bearer ${token}` };
};

export const getTpvMeta = async () => {
  const res = await axios.get(`${API_URL}/api/tpv/meta`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const listTpvCajas = async () => {
  const res = await axios.get(`${API_URL}/api/tpv/cajas`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createTpvCaja = async (importeIni) => {
  const res = await axios.post(
    `${API_URL}/api/tpv/cajas`,
    { importeIni },
    { headers: authHeaders() },
  );
  return res.data;
};

export const getTpvCaja = async (id) => {
  const res = await axios.get(`${API_URL}/api/tpv/cajas/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const closeTpvCaja = async (id, body) => {
  const res = await axios.post(`${API_URL}/api/tpv/cajas/${id}/close`, body, {
    headers: authHeaders(),
  });
  return res.data;
};

export const reopenTpvCaja = async (id) => {
  const res = await axios.post(
    `${API_URL}/api/tpv/cajas/${id}/reopen`,
    {},
    { headers: authHeaders() },
  );
  return res.data;
};

export const deleteTpvCaja = async (id) => {
  const res = await axios.delete(`${API_URL}/api/tpv/cajas/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const getTpvCajaPrint = async (id) => {
  const res = await axios.get(`${API_URL}/api/tpv/cajas/${id}/print`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createTpvTicket = async (cajaId) => {
  const res = await axios.post(
    `${API_URL}/api/tpv/cajas/${cajaId}/tickets`,
    {},
    { headers: authHeaders() },
  );
  return res.data;
};

export const getTpvTicket = async (id) => {
  const res = await axios.get(`${API_URL}/api/tpv/tickets/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const searchTpvProductos = async (q) => {
  const res = await axios.get(`${API_URL}/api/tpv/productos`, {
    headers: authHeaders(),
    params: { q },
  });
  return res.data;
};

export const addTpvLinea = async (ticketId, ean, extra = {}) => {
  const res = await axios.post(
    `${API_URL}/api/tpv/tickets/${ticketId}/lineas`,
    { ean, ...extra },
    { headers: authHeaders() },
  );
  return res.data;
};

export const patchTpvLinea = async (id, body) => {
  const res = await axios.patch(`${API_URL}/api/tpv/lineas/${id}`, body, {
    headers: authHeaders(),
  });
  return res.data;
};

export const deleteTpvLinea = async (id) => {
  const res = await axios.delete(`${API_URL}/api/tpv/lineas/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const cobroTpvTicket = async (id, body) => {
  const res = await axios.post(`${API_URL}/api/tpv/tickets/${id}/cobro`, body, {
    headers: authHeaders(),
  });
  return res.data;
};

export const reopenTpvTicket = async (id) => {
  const res = await axios.post(
    `${API_URL}/api/tpv/tickets/${id}/reopen`,
    {},
    { headers: authHeaders() },
  );
  return res.data;
};

export const deleteTpvTicket = async (id) => {
  const res = await axios.delete(`${API_URL}/api/tpv/tickets/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const getTpvTicketPrint = async (id) => {
  const res = await axios.get(`${API_URL}/api/tpv/tickets/${id}/print`, {
    headers: authHeaders(),
  });
  return res.data;
};
